import { Box, BoxProps, Chip, ChipProps } from '@mui/material';
import { FC } from 'react';
import useLocales from '~/hooks/useLocales';

type Props = {
  boxProps?: BoxProps;
  chipProps?: ChipProps;
};

const BetaChip: FC<Props> = ({ boxProps, chipProps }) => {
  const { t } = useLocales();

  return (
    <Box {...boxProps}>
      <Chip
        label={t('common.beta')}
        variant="filled"
        size="small"
        color="warning"
        sx={{ color: 'common.white', fontSize: '12px', fontWeight: 700 }}
        {...chipProps}
      />
    </Box>
  );
};

export default BetaChip;
